import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ErrorCorrectionEmbed from '../components/Exercise/ErrorCorrectionEmbed';

export default Node.create({
  name: 'errorCorrection',
  group: 'block',
  atom: true,
  draggable: true,
  addAttributes() {
    return {
      sentences: { 
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('sentences');
          if (data) {
            try {
              return JSON.parse(data);
            } catch (e) {
              console.error('Error parsing ErrorCorrection sentences from HTML:', e);
              return [];
            }
          }
          return [];
        },
        renderHTML: attributes => {
          if (attributes.sentences) {
            return {
              sentences: JSON.stringify(attributes.sentences)
            };
          }
          return {};
        }
      },
      title: { 
        default: 'Error Correction Exercise',
        parseHTML: element => element.getAttribute('title') || 'Error Correction Exercise',
        renderHTML: attributes => {
          if (attributes.title) {
            return {
              title: attributes.title
            };
          }
          return {};
        }
      },
      level: {
        default: 'B1',
        parseHTML: element => element.getAttribute('level') || 'B1',
        renderHTML: attributes => {
          if (attributes.level) {
            return {
              level: attributes.level
            };
          }
          return {};
        }
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {}
      }
    };
  },
  parseHTML() {
    return [
      { tag: 'div[data-type="error-correction"]' },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'error-correction' })];
  },
  addNodeView() {
    return ReactNodeViewRenderer(ErrorCorrectionEmbed);
  },
  addCommands() {
    return {
      insertErrorCorrection:
        (attributes) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
    };
  },
}); 